import React from 'react'

const Tabs = () => {
  return (
    <>
      <div className='flex flex-col my-[20px] p-[8px] bg-green-100 shadow-lg justify-center items-center space-y-2 '>
        <div className='flex flex-row space-x-10'>
            <div className='cursor-pointer hover:bg-blue-100 p-[12px] rounded-md' >
                <img src={require('../../Images/fashion2.jpg')} alt="" className='h-[350px] w-[320px]'/>
                <div className='text-center py-[12px]'>Fashion</div>
            </div>
            <div className='flex flex-col '>
                <div className='flex space-x-10'>
                    <div className='cursor-pointer hover:bg-blue-100 p-[12px] rounded-md'>
                        <img src={require('../../Images/appliances.jpg')} alt="" className='h-[140px] w-[300px]'/>
                        <div className='text-center py-[12px]'>Appliances</div>
                    </div>
                    <div className='cursor-pointer hover:bg-blue-100 p-[12px] rounded-md'>
                        <img src={require('../../Images/electronics.jpg')} alt="" className='h-[140px] w-[300px]'/>
                        <div className='text-center py-[12px]'>Electronics</div>
                    </div>
                </div>
                <div className='flex space-x-10'>
                    <div className='cursor-pointer hover:bg-blue-100 p-[12px] rounded-md'>
                        <img src={require('../../Images/mobile-2.jpg')} alt="" className='h-[140px] w-[300px]'/>
                        <div className='text-center py-[12px]'>Mobile</div>
                    </div>
                    <div className='cursor-pointer hover:bg-blue-100 p-[12px] rounded-md'>
                        <img src={require('../../Images/laptop.jpg')} alt="" className='h-[140px] w-[300px]'/>
                        <div className='text-center py-[12px]'>Laptop</div>
                    </div>
                </div>
            </div>
        </div>
        <div className='flex border border-blue-200 space-x-2'>
            <div className='flex flex-col bg-blue-100 border border-blue-200 justify-center items-center'>
                <div className='flex space-x-1 justify-center items-center'>
                    <div className='cursor-pointer hover:bg-blue-100 p-[12px] rounded-md'>
                        {/* <img src={require('../../Images/appliances.jpg')} alt="" className='h-[100px] w-[150px]'/> */}
                        <div className='bg-yellow-500 h-[50px] w-[50px] rounded-[50%]'>
                            <p className='relative top-[20px] left-[18px] text-[10px] font-bold'>Pay</p>
                        </div>
                        <div className='text-center text-[12px] py-[2px]'>Shop33 Pay</div>
                    </div>
                    <div className='cursor-pointer hover:bg-blue-100 p-[12px] rounded-md'>
                        <img src={require('../../Images/travel.jpg')} alt="" className='h-[50px] w-[80px]'/>
                        <div className='text-center text-[12px] py-[2px]'>Travel</div>
                    </div>
                </div>
                <div className='flex space-x-8 justify-center items-center '>
                    <div className='cursor-pointer hover:bg-blue-100 p-[12px] rounded-md'>
                        <img src={require('../../Images/qrCode.png')} alt="" className='h-[60px] w-[50px]'/>
                        <div className='text-center text-[12px] py-[2px]'>Scan</div>
                    </div>
                    <div className='cursor-pointer hover:bg-blue-100 p-[12px] rounded-md'>
                        <img src={require('../../Images/bills.png')} alt="" className='h-[60px] w-[50px]'/>
                        <div className='text-center text-[12px] py-[2px]'>Pay Bills</div>
                    </div>
                </div>
            </div>
            <div className='cursor-pointer hover:bg-blue-100 p-[12px] rounded-md'>
                <img src={require('../../Images/medicine2.jpg')} alt="" className='h-[140px] w-[170px]'/>
                <div className='text-center pt-[12px]'>Medicine</div>
            </div>
            <div className='cursor-pointer hover:bg-blue-100 p-[12px] rounded-md'>
                <img src={require('../../Images/sports.jpg')} alt="" className='h-[140px] w-[170px]'/>
                <div className='text-center pt-[12px]'>Sports</div>
            </div>
            <div className='cursor-pointer hover:bg-blue-100 p-[12px] rounded-md'>
                <img src={require('../../Images/homeAppliances.jpg')} alt="" className='h-[140px] w-[170px]'/>
                <div className='text-center pt-[12px]'>Home Appliances</div>
            </div>
            <div className='cursor-pointer hover:bg-blue-100 p-[12px] rounded-md'>
                <img src={require('../../Images/makeup.jpg')} alt="" className='h-[140px] w-[170px]'/>
                <div className='text-center pt-[12px]'>Personal Care</div>
            </div>
            <div className='cursor-pointer hover:bg-blue-100 p-[12px] rounded-md'>
                <img src={require('../../Images/grocery.jpg')} alt="" className='h-[140px] w-[170px]'/>
                <div className='text-center pt-[12px]'>Grocery</div>
            </div>
        </div>
      </div>
    </>
  )
}

export default Tabs
